import React from 'react';
import { useTranslation } from 'react-i18next';

import { CrossIcon } from '../../../../assets';
import { Button } from '../../../Button';
import { Flex } from '../../../Flex';
import { Modal } from '../../../Modal';
import { Typography } from '../../../Typography';
import { ColumnSettingsList } from './ColumnSettingsList';
import { useColumnSettingsDraft } from './useColumnSettingsDraft';

import styles from './TableColumnSettings.module.scss';

export interface ITableColumnSettingsModalProps {
    onClose: () => void;
}

export const TableColumnSettingsModal: React.FC<ITableColumnSettingsModalProps> = ({ onClose }) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'table.columnSettings' });
    const { items, visibleCount, toggle, move, reset, save } = useColumnSettingsDraft();

    const handleSave = () => {
        save();
        onClose();
    };

    const header = (
        <Flex align="center" flex={1} justify="between">
            <Typography component="h2" fontWeight="bold" variant="h4">
                {t('title')}
            </Typography>
            <Button
                aria-label={t('cancel')}
                color="transparent"
                onClick={onClose}
                rounded="full"
                size="small"
                variant="fab"
            >
                <CrossIcon />
            </Button>
        </Flex>
    );
    const footer = (
        <Flex align="center" flex={1} gap={2} justify="between">
            <Button onClick={reset} size="small" variant="ghost">
                {t('reset')}
            </Button>
            <Flex gap={2}>
                <Button color="light" onClick={onClose} size="small">
                    {t('cancel')}
                </Button>
                <Button onClick={handleSave} size="small">
                    {t('save')}
                </Button>
            </Flex>
        </Flex>
    );

    return (
        <Modal className={styles.modal} footer={footer} header={header} onClose={onClose} open>
            <Typography color="secondary" variant="base12">
                {t('description')}
            </Typography>
            <div>
                <Flex className={styles.listHeader} justify="between">
                    <Typography color="secondary" variant="base12">
                        {t('column')}
                    </Typography>
                    <Typography color="secondary" variant="base12">
                        {t('visibleCount', { visible: visibleCount, total: items.length })}
                    </Typography>
                </Flex>
                <ColumnSettingsList items={items} onMove={move} onToggle={toggle} visibleCount={visibleCount} />
            </div>
        </Modal>
    );
};
